import { z } from "zod";

const FRENCH_PHONE_REGEX = /^(?:\+33|0033|0)[1-9](?:\d{2}){4}$/;

export const createRecommendationSchema = z.object({
  first_name: z.string().min(1, "Le prénom est requis"),
  last_name: z.string().min(1, "Le nom est requis"),
  email: z
    .string()
    .min(1, "L'email est requis")
    .email("L'email n'est pas valide"),
  phone: z
    .string()
    .min(1, "Le téléphone est requis")
    .regex(FRENCH_PHONE_REGEX, "Le numéro de téléphone n'est pas valide"),
  cse: z.string().min(1, "Le nom du CSE est requis"),
});

export type CreateRecommendationFormData = z.infer<typeof createRecommendationSchema>;
